export const leadStatusValidationRules = (values) => {
  const errors = {};

  if (!values.name) errors.name = "Status is required";
  if (values.name && values.name.length < 3) errors.name = "Status must be at least 3 characters";

  return errors;
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const leadValidationRules = (values, isUpdate) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.contactName) errors.contactName = "Contact Name is required";
  else if (values.contactName.length < 3) errors.contactName = "Contact Name must be at least 3 characters";
  if (!values.contactPhone) errors.contactPhone = "Mobile number is required";
  else if (!phoneRegex.test(values.contactPhone)) errors.contactPhone = "Enter valid number (with country code)";

  if (values.contactEmail && !emailRegex.test(values.contactEmail)) errors.contactEmail = "Enter a valid email address";

  if (values.expectedBudget !== "" && values.expectedBudget != null && Number(values.expectedBudget) < 0) {
    errors.expectedBudget = "Budget cannot be negative";
  }

  if (!isUpdate && !values.priorityId) errors.priorityId = "Please select a priority";

  return errors;
};

export const leadActivityValidationRules = (values) => {
  const errors = {};

  if (!values.note) errors.note = "Please add a note";
  if (values.note && values.note.length < 5) errors.note = "Note must be at least 5 characters";
  const hasAssignees = Array.isArray(values.assignees) && values.assignees.length > 0;
  if (!hasAssignees) errors.assignees = "Please select at least one assignee";

  return errors;
};
